import styled from "styled-components";

const GroupLabel = styled.div`
    display: flex;
    align-items: center;
    flex-grow: 1;
    display: flex;
`;

export default GroupLabel;
